import { render, staticRenderFns } from "./AverageAgeByGender.vue?vue&type=template&id=802e305c&scoped=true&"
import script from "./AverageAgeByGender.vue?vue&type=script&lang=js&"
export * from "./AverageAgeByGender.vue?vue&type=script&lang=js&"
import style0 from "./AverageAgeByGender.vue?vue&type=style&index=0&id=802e305c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "802e305c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VCard,VCardText,VCardTitle,VOverlay,VProgressLinear})
